(function () {
  const initSlider = (section) => {
    const slider = section.querySelector(".exo-steps-grid__swiper");

    if (!slider) return;

    const columns = Number(slider.dataset.columns);
    const columnsConfig = {
         6: {
        750: { slidesPerView: 4 },
        1200: { slidesPerView: 5 },
        1360: { slidesPerView: 6 },
      },
        5: {
        750: { slidesPerView: 3 },
        1200: { slidesPerView: 4 },
        1360: { slidesPerView: 5 },
      },
      4: {
        750: { slidesPerView: 2 },
        1200: { slidesPerView: 3 },
        1360: { slidesPerView: 4 },
      },
      3: {
        750: { slidesPerView: 2 },
        1200: { slidesPerView: 3 },
      },
      2: {
        750: { slidesPerView: 2 },
      },
      1: {
        576: { slidesPerView: 1 },
      },
    };

    const testimonialsSwiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: false,
      speed: 800,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
          nextEl: section.querySelector('.cards-grid__navigation-button-next'),
          prevEl: section.querySelector('.cards-grid__navigation-button-prev'),
          disabledClass: "swiper-button-disabled",
        },
      breakpoints: columnsConfig[columns],
    });
  };

  initSlider(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSlider(event.target);
  });
})();
